import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { StudioPage } from "@/features/studio/studio";

const search = z.object({ tab: z.enum(["captions", "images", "scorer", "history"]).optional(), gen: z.string().uuid().optional() }); // gen: open an AI generation (toast "View")

export const Route = createFileRoute("/_app/studio")({
  validateSearch: search,
  head: () => ({ meta: [{ title: "AI Studio · Malfak" }] }),
  component: Studio,
});

function Studio() {
  const { tab, gen } = Route.useSearch();
  return <StudioPage tab={tab ?? "captions"} gen={gen} />;
}
